import { render, staticRenderFns } from "./PercentageBar.vue?vue&type=template&id=1ecb5b28&scoped=true&"
import script from "./PercentageBar.vue?vue&type=script&lang=js&"
export * from "./PercentageBar.vue?vue&type=script&lang=js&"
import style0 from "./PercentageBar.vue?vue&type=style&index=0&id=1ecb5b28&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ecb5b28",
  null
  
)

export default component.exports